import { render, staticRenderFns } from "./changkou.vue?vue&type=template&id=3dcb664a&scoped=true&"
import script from "./changkou.vue?vue&type=script&lang=ts&"
export * from "./changkou.vue?vue&type=script&lang=ts&"
import style0 from "./changkou.vue?vue&type=style&index=0&id=3dcb664a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcb664a",
  null
  
)

export default component.exports